// Centralized data-testids for Namya Health frontend
export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  disease: "nav-know-your-disease",
  medications: "nav-know-your-medications",
  diet: "nav-diet",
  exercise: "nav-exercise",
  bookCta: "nav-book-appointment",
  mobileToggle: "nav-mobile-toggle",
};

export const HOME = {
  hero: "home-hero",
  heroCta: "home-hero-book-btn",
  uspBadge: "home-usp-badge",
  aboutSection: "home-about-section",
  servicesSection: "home-services-section",
  serviceCard: (slug) => `home-service-${slug}`,
  bookingSection: "home-booking-section",
};

export const BOOKING = {
  form: "booking-form",
  name: "booking-name",
  phone: "booking-phone",
  email: "booking-email",
  age: "booking-age",
  condition: "booking-condition",
  date: "booking-date",
  time: "booking-time",
  message: "booking-message",
  submit: "booking-submit",
  successDialog: "booking-success-dialog",
  successClose: "booking-success-close",
};

export const DISEASE = {
  hub: "disease-hub",
  search: "disease-search",
  diseaseGroup: (slug) => `disease-group-${slug}`,
  blogCard: (id) => `disease-blog-card-${id}`,
  blogDetail: "disease-blog-detail",
  blogBack: "disease-blog-back",
};

export const MED = {
  hub: "med-hub",
  search: "med-search",
  card: (id) => `med-card-${id}`,
  detail: "med-detail",
  backLink: "med-back-link",
};

export const DIET = {
  page: "diet-page",
  search: "diet-search",
  tabBlogs: "diet-tab-blogs",
  tabVideos: "diet-tab-videos",
  blogCard: (id) => `diet-blog-card-${id}`,
  videoCard: (id) => `diet-video-card-${id}`,
  videoDialog: "diet-video-dialog",
  blogDetail: "diet-blog-detail",
  blogBack: "diet-blog-back",
};

export const EXERCISE = {
  page: "exercise-page",
  search: "exercise-search",
  tabBlogs: "exercise-tab-blogs",
  tabVideos: "exercise-tab-videos",
  blogCard: (id) => `exercise-blog-card-${id}`,
  videoCard: (id) => `exercise-video-card-${id}`,
  videoDialog: "exercise-video-dialog",
  blogDetail: "exercise-blog-detail",
  blogBack: "exercise-blog-back",
};

export const ADMIN = {
  page: "admin-page",
  tokenInput: "admin-token-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  tabAppointments: "admin-tab-appointments",
  tabBlogs: "admin-tab-blogs",
  tabMedications: "admin-tab-medications",
  tabDietBlogs: "admin-tab-diet-blogs",
  tabDietVideos: "admin-tab-diet-videos",
  tabExerciseBlogs: "admin-tab-exercise-blogs",
  tabExerciseVideos: "admin-tab-exercise-videos",

  bookingsTable: "admin-bookings-table",
  bookingRow: (id) => `admin-booking-row-${id}`,

  blogList: "admin-blog-list",
  blogRow: (id) => `admin-blog-row-${id}`,
  blogCreateBtn: "admin-blog-create-btn",
  blogEditBtn: (id) => `admin-blog-edit-${id}`,
  blogDeleteBtn: (id) => `admin-blog-delete-${id}`,
  blogFormTitle: "admin-blog-form-title",
  blogFormDisease: "admin-blog-form-disease",
  blogFormExcerpt: "admin-blog-form-excerpt",
  blogFormBody: "admin-blog-form-body",
  blogFormSave: "admin-blog-form-save",
  blogFormCancel: "admin-blog-form-cancel",

  medList: "admin-med-list",
  medRow: (id) => `admin-med-row-${id}`,
  medCreateBtn: "admin-med-create-btn",
  medEditBtn: (id) => `admin-med-edit-${id}`,
  medDeleteBtn: (id) => `admin-med-delete-${id}`,
  medFormName: "admin-med-form-name",
  medFormClass: "admin-med-form-class",
  medFormDisease: "admin-med-form-disease",
  medFormUses: "admin-med-form-uses",
  medFormBody: "admin-med-form-body",
  medFormSave: "admin-med-form-save",
  medFormCancel: "admin-med-form-cancel",

  dietBlogList: "admin-diet-blog-list",
  dietBlogRow: (id) => `admin-diet-blog-row-${id}`,
  dietBlogCreateBtn: "admin-diet-blog-create-btn",
  dietBlogEditBtn: (id) => `admin-diet-blog-edit-${id}`,
  dietBlogDeleteBtn: (id) => `admin-diet-blog-delete-${id}`,
  dietBlogFormTitle: "admin-diet-blog-form-title",
  dietBlogFormExcerpt: "admin-diet-blog-form-excerpt",
  dietBlogFormTags: "admin-diet-blog-form-tags",
  dietBlogFormBody: "admin-diet-blog-form-body",
  dietBlogFormSave: "admin-diet-blog-form-save",
  dietBlogFormCancel: "admin-diet-blog-form-cancel",

  dietVideoList: "admin-diet-video-list",
  dietVideoRow: (id) => `admin-diet-video-row-${id}`,
  dietVideoCreateBtn: "admin-diet-video-create-btn",
  dietVideoEditBtn: (id) => `admin-diet-video-edit-${id}`,
  dietVideoDeleteBtn: (id) => `admin-diet-video-delete-${id}`,
  dietVideoFormTitle: "admin-diet-video-form-title",
  dietVideoFormYoutube: "admin-diet-video-form-youtube",
  dietVideoFormDescription: "admin-diet-video-form-description",
  dietVideoFormTags: "admin-diet-video-form-tags",
  dietVideoFormSave: "admin-diet-video-form-save",
  dietVideoFormCancel: "admin-diet-video-form-cancel",

  exerciseBlogList: "admin-exercise-blog-list",
  exerciseBlogRow: (id) => `admin-exercise-blog-row-${id}`,
  exerciseBlogCreateBtn: "admin-exercise-blog-create-btn",
  exerciseBlogEditBtn: (id) => `admin-exercise-blog-edit-${id}`,
  exerciseBlogDeleteBtn: (id) => `admin-exercise-blog-delete-${id}`,
  exerciseBlogFormTitle: "admin-exercise-blog-form-title",
  exerciseBlogFormExcerpt: "admin-exercise-blog-form-excerpt",
  exerciseBlogFormTags: "admin-exercise-blog-form-tags",
  exerciseBlogFormBody: "admin-exercise-blog-form-body",
  exerciseBlogFormSave: "admin-exercise-blog-form-save",
  exerciseBlogFormCancel: "admin-exercise-blog-form-cancel",

  exerciseVideoList: "admin-exercise-video-list",
  exerciseVideoRow: (id) => `admin-exercise-video-row-${id}`,
  exerciseVideoCreateBtn: "admin-exercise-video-create-btn",
  exerciseVideoEditBtn: (id) => `admin-exercise-video-edit-${id}`,
  exerciseVideoDeleteBtn: (id) => `admin-exercise-video-delete-${id}`,
  exerciseVideoFormTitle: "admin-exercise-video-form-title",
  exerciseVideoFormYoutube: "admin-exercise-video-form-youtube",
  exerciseVideoFormDescription: "admin-exercise-video-form-description",
  exerciseVideoFormTags: "admin-exercise-video-form-tags",
  exerciseVideoFormSave: "admin-exercise-video-form-save",
  exerciseVideoFormCancel: "admin-exercise-video-form-cancel",
};

export const FOOTER = {
  root: "footer",
  address: "footer-address",
  hours: "footer-hours",
};
